import { createRouter, createWebHistory } from "vue-router";
import LoginC from "@/vistas/login.vue";
import DashboardPrincipal from "@/vistas/DashboardPrincipal.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import vistaReserva from "@/vistas/realizarReserva.vue";
import ReservasGestion from "@/components/hotel/reservas.vue";
import PagarReserva from "@/components/hotel/pagarreserva.vue";
import checkInHabitaciones from "@/components/hotel/check-in.vue";
import checkOutHabitaciones from "@/components/hotel/check-out.vue";
import LimpiezaHabitaciones from "@/components/hotel/limpieza-habitaciones.vue";
import ValidarDiaExtraF from "@/components/hotel/ValidarDiaExtra.vue";
import GenerarCodigo from "@/components/codigodescuento.vue";
import store from "@/store";
import ListaEsperaView from "@/components/hotel/listaespera.vue";
import ProductosTienda from "@/components/hotel/inventarioTienda.vue";
import VentaTienda from "@/components/hotel/ventatienda.vue";
import DetalleReserva from "@/components/hotel/detallesreserva.vue";
import VentaServiciosExtra from "@/components/hotel/ventaserviciosextra.vue";
import ServiciosExtraHotel from "@/components/hotel/serviciosextra.vue";
import EmpleadosGestion from "@/components/empleados.vue";
import RolesGestion from "@/components/roles.vue";
import PromocionesHabitacionesGestion from "@/components/hotel/promocioneshabitaciones.vue";
import HabitacionGestion from "@/components/hotel/habitaciones.vue";
import TipoHabitacionGestion from "@/components/hotel/tipohabitacion.vue";
import TarifaPersonaGestion from "@/components/hotel/tarifahabitacion.vue";
import CuentaBancariaGestion from "@/components/cuentabancaria.vue";
import ReportePagosDia from "@/components/reportes/totalpordia.vue";
import HabitacionMantenimiento from "@/components/hotel/ponerhabitacionenmantenimiento.vue";
import Gestionmantenimiento from "@/components/hotel/gestionmantenimiento.vue";
import MantenimientoEstado from "@/components/hotel/gestiondeestadosmantenimiento.vue";
import RecepcionistaLimpieza from "@/components/hotel/marcarprioridaddelimpieza.vue";
import InventarioGeneralHotel from "@/components/hotel/inventariogeneralhote.vue";
import Comprasinventariogeneral from "@/components/hotel/comprasinventariogeneral.vue";
import Movimientoinventarios from "@/components/hotel/movimientoinventarios.vue";
import Salidasinventarioshotel from "@/components/hotel/salidasinventarioshotel.vue";
import Gastosgeneraleshotel from "@/components/hotel/gastosgeneraleshotel.vue";
import Inventariorecepcion from "@/components/hotel/inventariorecepcion.vue";
import Inventariolavanderia from "@/components/hotel/inventariolavanderia.vue";
import InventarioSobrante from "@/components/hotel/inventariosobrante.vue";
import Supervisionlimpieza from "@/components/hotel/supervisionlimpieza.vue";
import Liberarhabitaciones from "@/components/hotel/liberarhabitaciones.vue";
import ListadoHuesped from "@/components/hotel/huesped.vue";
import Observacionesdelimpieza from "@/components/hotel/observacionesdelimpieza.vue";
import NotasSupervision from "@/components/hotel/notassupervision.vue";
import PagosEmpleados from "@/components/hotel/pagospendientesempleados.vue";
import ReservasReducir from "@/components/hotel/gestionreservaadm.vue";
import ReducirReserva from "@/components/hotel/reducirreservas.vue";
import CierreCajaDetalle from "@/components/reportes/cierrecaja.vue";
import ImprimirCierreCaja from "@/components/reportes/imprimircierredecaja.vue";
import DepositoEfectivo from "@/components/reportes/depositoefectivo.vue";
import Cajachica from "@/components/hotel/cajachica.vue";
import Cambiarhabitacion from "@/components/hotel/cambiarhabitacion.vue";
import ImprimirCambioHabitacion from "@/components/hotel/imprimirrecibocambiohabitacion.vue";
import ReporteLavanderiaDiaria from "@/components/hotel/imprimirreportedelimpieza.vue";
import Inventariogeneralrestaurante from "@/components/restaurante/inventarios/inventariogeneralrestaurante.vue";
import Tiposproductorestaurante from "@/components/restaurante/inventarios/tiposproductorestaurante.vue";
import Comprasinventariogeneralrestaurante from "@/components/restaurante/inventarios/comprasinventariogeneralrestaurante.vue";
import Inventariomobiliariorestaurante from "@/components/restaurante/inventarios/inventariomobiliariorestaurante.vue";
import Movimientoinventariosrestaurante from "@/components/restaurante/inventarios/movimientoinventariosrestaurante.vue";
import Inventariolimpiezarestaurante from "@/components/restaurante/inventarios/inventariolimpiezarestaurante.vue";
import Inventariobarra from "@/components/restaurante/inventarios/inventariobarra.vue";
import Inventariococina from "@/components/restaurante/inventarios/inventariococina.vue";
import Salidasinventariosrestaurante from "@/components/restaurante/inventarios/salidasinventariosrestaurante.vue";
import OpcionesComida from "@/components/restaurante/comida/opciones.vue";
import Grupoopciones from "@/components/restaurante/comida/grupoopciones.vue";
import PlatillosRestaurante from "@/components/restaurante/comida/platillos.vue";
import Categoriaplatillos from "@/components/restaurante/comida/categoriaplatillos.vue";
import MesasRestaurante from "@/components/restaurante/pedidos/mesas.vue";
import MesasRestaurantePedido from "@/components/restaurante/pedidos/seleccionarmesa.vue";
import MenuMesero from "@/components/restaurante/pedidos/generarpedido.vue";
import PantallaCocina from "@/components/restaurante/pedidos/pantallacocina.vue";
import PantallaBarra from "@/components/restaurante/pedidos/pantallabarra.vue";
import CuentasPedidoDetalles from "@/components/restaurante/cuentas/detallescuentaspedido.vue";
import CuentasPendientes from "@/components/restaurante/pagarcuentas/vercuentaspendientes.vue";
import CuentasCargadasHabitacion from "@/components/restaurante/pagarcuentas/cuentascargadashabitacion.vue";
import PagarCuentaPedido from "@/components/restaurante/pagarcuentas/pagarcuenta.vue";
import DetalleReservaPublico from "@/components/hotel/cancelarreservapublico.vue";
import Empaqueplatillos from "@/components/restaurante/comida/empaqueplatillos.vue";
import PropinasRestaurante from "@/components/reportes/propinarestaurante.vue";
import InventarioGlobal from "@/components/reportes/inventarioglobal.vue";
import HistorialComandas from "@/components/restaurante/reportes/HistorialComandas.vue";
import HistorialPagosRestaurante from "@/components/restaurante/reportes/HistorialPagosRestaurante.vue";
import PagarReservaHotel from "@/components/hotel/pagarreserva.vue";
import PagarPorHabitaciones from "@/components/hotel/pagos/pagarporhabitaciones.vue";
import ReportesRestaurante from "@/components/restaurante/reportes/reportesrestaurante.vue";
import ReportesHotel from "@/components/hotel/reportes/reporteshotel.vue";
import ReporteCamas from "@/components/hotel/reportes/reportecamas.vue";
import HistorialPagosHotel from "@/components/hotel/reportes/HistorialPagosHotel.vue";
import CuentasPendientesAdministrador from "@/components/restaurante/pagarcuentas/cuentaspendientesadm.vue";
import ReservasPendientesDePago from "@/components/hotel/pendientesdepago.vue";
import CierreCajaPorFechas from "@/components/reportes/cierrecajaporfechas.vue";
import Ingresoshospedaje from "@/components/reportes/ingresoshospedaje.vue";
import DashboardContador from "@/components/dashboards/DashboardContador.vue";
import IngresosDiarios from "@/components/contabilidad/IngresosDiarios.vue";
import CorteVentas from "@/components/contabilidad/CorteVentas.vue";
import LiquidacionTarjetas from "@/components/contabilidad/LiquidacionTarjetas.vue";
import PagosPorCredito from "@/components/contabilidad/PagosPorCredito.vue";
import CajaChicaAdmin from "@/components/contabilidad/CajaChicaAdmin.vue";
import NoFacturado from "@/components/contabilidad/NoFacturado.vue";
import FacturasAnuladas from "@/components/contabilidad/FacturasAnuladas.vue";
import PaginaExtras from "@/vistas/PaginaExtras.vue";

const routes = [
  { path: "/ver-detalle-publico/:codigo", component: DetalleReservaPublico },
  {
    path: "/pantalla-cocina-publica",
    name: "PantallaCocinaPublica",
    component: PantallaCocina,
    meta: { publica: true },
  },
  {
    path: "/pantalla-barra-publica",
    name: "PantallaBarraPublica",
    component: PantallaBarra,
    meta: { publica: true },
  },
  {
    path: "/menu/:token",
    name: "MenuPublico",
    component: () => import("@/vistas/MenuPublico.vue"),
    meta: { publica: true },
  },
  // Redirige a /login por defecto
  { path: "/", redirect: "/login" },

  // Página de login sin layout
  { path: "/login", component: LoginC },

  // Rutas con sidebar (usando MainLayout)
  {
    path: "/",
    component: MainLayout,
    children: [
      {
        path: "inicio", // se accede como /inicio
        component: DashboardPrincipal,
      },
      {
        path: "crear-reserva", // se accede como
        component: vistaReserva,
      },
      {
        path: "reservas",
        component: ReservasGestion,
      },
      {
        path: "pagar-reserva/:id",
        component: PagarReserva,
        name: "PagarReserva",
      },
      {
        path: "check-in/:id",
        component: checkInHabitaciones,
        name: "checkInHabitaciones",
      },
      {
        path: "check-out/:id",
        component: checkOutHabitaciones,
        name: "checkOutHabitaciones",
      },
      {
        path: "validar-dia-extra/:id",
        component: ValidarDiaExtraF,
        name: "ValidarDiaExtraF",
      },
      {
        path: "ver-detalles-reserva/:id",
        component: DetalleReserva,
        name: "VerDetallesReservas",
      },
      {
        path: "limpieza-Habitaciones",
        component: LimpiezaHabitaciones,
      },
      {
        path: "crear-codigos-descuento",
        component: GenerarCodigo,
      },
      {
        path: "clientes-en-espera",
        component: ListaEsperaView,
      },
      {
        path: "inventario-tienda",
        component: ProductosTienda,
      },
      {
        path: "venta-tienda",
        component: VentaTienda,
      },
      {
        path: "venta-servicios-extras",
        component: VentaServiciosExtra,
      },
      {
        path: "servicios-extra",
        component: ServiciosExtraHotel,
      },
      {
        path: "gestion-empleados",
        component: EmpleadosGestion,
      },
      {
        path: "gestion-roles",
        component: RolesGestion,
      },
      {
        path: "gestion-promociones-habitaciones",
        component: PromocionesHabitacionesGestion,
      },
      {
        path: "gestion-habitaciones",
        component: HabitacionGestion,
      },
      {
        path: "gestion-tipo-habitaciones",
        component: TipoHabitacionGestion,
      },
      {
        path: "gestion-tarifa-habitaciones",
        component: TarifaPersonaGestion,
      },
      {
        path: "gestion-cuentas-bancarias",
        component: CuentaBancariaGestion,
      },
      {
        path: "reporte-pagos-dia",
        component: ReportePagosDia,
      },
      {
        path: "habitaciones-mantenimiento",
        component: HabitacionMantenimiento,
      },
      {
        path: "gestion-mantenimiento",
        component: Gestionmantenimiento,
      },
      {
        path: "control-mantenimiento",
        component: MantenimientoEstado,
      },
      {
        path: "priorizar-limpieza",
        component: RecepcionistaLimpieza,
      },
      {
        path: "inventario-general-hotel",
        component: InventarioGeneralHotel,
      },
      {
        path: "compras-inventario-general-hotel",
        component: Comprasinventariogeneral,
      },
      {
        path: "movimiento-inventarios-hotel",
        component: Movimientoinventarios,
      },
      {
        path: "salidas-inventarios-hotel",
        component: Salidasinventarioshotel,
      },
      {
        path: "gastos-generales-hotel",
        component: Gastosgeneraleshotel,
      },
      {
        path: "inventario-recepcion",
        component: Inventariorecepcion,
      },
      {
        path: "inventario-lavanderia",
        component: Inventariolavanderia,
      },
      {
        path: "inventario-sobrante",
        component: InventarioSobrante,
      },
      {
        path: "supervisar-limpieza",
        component: Supervisionlimpieza,
      },
      {
        path: "liberar-habitaciones",
        component: Liberarhabitaciones,
      },
      {
        path: "listado-huesped",
        component: ListadoHuesped,
      },
      {
        path: "observaciones-limpieza",
        component: Observacionesdelimpieza,
      },
      {
        path: "notas-supervision",
        component: NotasSupervision,
      },
      {
        path: "pagos-empleados",
        component: PagosEmpleados,
      },
      {
        path: "reducir-reservas-admin",
        component: ReservasReducir,
      },
      {
        path: "reducir-reserva/:id",
        component: ReducirReserva,
        name: "ReducirReserva",
      },
      {
        path: "cierre-caja-diario",
        component: CierreCajaDetalle,
      },
      {
        path: "cierre-caja-fechas",
        component: CierreCajaPorFechas,
      },
      {
        path: "imprimir-cierre-caja",
        component: ImprimirCierreCaja,
      },
      {
        path: "depositos-efectivo",
        component: DepositoEfectivo,
      },
      {
        path: "caja-chica",
        component: Cajachica,
      },
      {
        path: "cambiar-habitacion-reserva/:id",
        component: Cambiarhabitacion,
        name: "CambiarHabitacion",
      },
      {
        path: "imprimir-cambios-habitacion",
        component: ImprimirCambioHabitacion,
      },
      {
        path: "imprimir-reporte-limpieza",
        component: ReporteLavanderiaDiaria,
      },

      ///RESTAURANTE ---------------------------

      //inventarios

      {
        path: "tipos-producto-restaurante",
        component: Tiposproductorestaurante,
      },
      {
        path: "inventario-general-restaurante",
        component: Inventariogeneralrestaurante,
      },
      {
        path: "compras-inventariogeneral-restaurante",
        component: Comprasinventariogeneralrestaurante,
      },
      {
        path: "inventario-mobiliario-restaurante",
        component: Inventariomobiliariorestaurante,
      },
      {
        path: "movimientos-inventarios-restaurante",
        component: Movimientoinventariosrestaurante,
      },
      {
        path: "inventario-limpieza-restaurante",
        component: Inventariolimpiezarestaurante,
      },
      {
        path: "inventario-barra",
        component: Inventariobarra,
      },
      {
        path: "inventario-cocina",
        component: Inventariococina,
      },
      {
        path: "salidas-inventarios-restaurante",
        component: Salidasinventariosrestaurante,
      },
      //comida
      {
        path: "opciones-guarniciones",
        component: OpcionesComida,
      },
      {
        path: "grupos-opciones-guarniciones",
        component: Grupoopciones,
      },
      {
        path: "platillos-restaurante",
        component: PlatillosRestaurante,
      },
      { path: "empaque-platillos", component: Empaqueplatillos },
      {
        path: "categorias-platillos",
        component: Categoriaplatillos,
      },

      //Pedidos y Mesas
      {
        path: "mesas",
        component: MesasRestaurante,
      },
      {
        path: "menu-mesero/:idMesa",
        component: MenuMesero,
        name: "MenuMesero",
      },
      {
        path: "seleccionar-mesa",
        component: MesasRestaurantePedido,
      },
      {
        path: "pantalla-cocina",
        component: PantallaCocina,
      },
      {
        path: "pantalla-barra",
        component: PantallaBarra,
      },
      //cuentas del pedido
      {
        path: "cuentas-del-pedido/:idPedido",
        component: CuentasPedidoDetalles,
        name: "CuentasPedidoDetalles",
      },
      {
        path: "cuentas-pendientes-mesas",
        component: CuentasPendientes,
      },
      {
        path: "cuentas-cargadas-habitacion",
        component: CuentasCargadasHabitacion,
        name: "CuentasCargadasHabitacion",
      },
      {
        path: "pagar-cuenta-pedido/:idCuenta",
        component: PagarCuentaPedido,
        name: "PagarCuentaPedido",
      },
      {
        path: "propinas-restaurante",
        component: PropinasRestaurante,
      },
      {
        path: "inventario-global",
        component: InventarioGlobal,
      },
      {
        path: "historial-comandas",
        component: HistorialComandas,
      },
      {
        path: "historial-pagos-restaurante",
        component: HistorialPagosRestaurante,
      },
      {
        path: "pagar-reserva/:id",
        component: PagarReservaHotel,
      },
      {
        path: "pagar-por-habitacion/:id",
        component: PagarPorHabitaciones,
      },
      {
        path: "reportes-restaurante",
        component: ReportesRestaurante,
      },
      {
        path: "reportes-hotel",
        component: ReportesHotel,
      },
      {
        path: "reporte-camas",
        component: ReporteCamas,
      },
      {
        path: "cuentas-pendientes-administracion",
        component: CuentasPendientesAdministrador,
      },
      {
        path: "reservas-pendientes-de-pago",
        component: ReservasPendientesDePago,
      },
      {
        path: "historial-pagos-hotel",
        component: HistorialPagosHotel,
      },
      {
        path: "ingresos-hospedaje",
        component: Ingresoshospedaje,
      },
      // ── Contabilidad (rol 11) ──────────────────────────────────────
      {
        path: "contabilidad/dashboard",
        component: DashboardContador,
      },
      {
        path: "contabilidad/ingresos-diarios",
        component: IngresosDiarios,
      },
      {
        path: "contabilidad/corte-ventas",
        component: CorteVentas,
      },
      {
        path: "contabilidad/liquidacion-tarjetas",
        component: LiquidacionTarjetas,
      },
      {
        path: "contabilidad/pagos-credito",
        component: PagosPorCredito,
      },
      {
        path: "contabilidad/caja-chica-admin",
        component: CajaChicaAdmin,
      },
      {
        path: "contabilidad/no-facturado",
        component: NoFacturado,
      },
      {
        path: "contabilidad/facturas-anuladas",
        component: FacturasAnuladas,
      },
      // ── Extras / Mantenimiento (Solo Administrador) ───────────────
      {
        path: "extrasadmin",
        component: PaginaExtras,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // Rutas marcadas como públicas no requieren autenticación
  if (to.meta?.publica) return next();

  const isAuthenticated = store.getters.isAuthenticated;
  const user = store.getters.getUser;

  // Rutas públicas permitidas SIN login
  const rutasPublicas = [
    "/login",
    "/ver-detalle-publico/", // base de la ruta pública
  ];

  // Si la ruta inicia con /ver-detalle-publico NO requiere autenticación
  if (to.path.startsWith("/ver-detalle-publico")) {
    return next();
  }

  // Si NO está autenticado y NO es ruta pública → enviarlo al login
  if (!isAuthenticated && !rutasPublicas.includes(to.path)) {
    return next("/login");
  }

  // RESTRICCIONES POR ROL ↓↓↓
  // Roles: 1=Administrador, 2=Recepcionista, 3=Limpieza, 4=Mantenimiento, 5=Encargado inventarios

  // Solo Administrador
  const rutasSoloAdm = [
    "/gestion-promociones-habitaciones",
    "/pagos-empleados",
    "/reducir-reservas-admin",
    "/gestion-empleados",
    "/gestion-roles",
    "/gestion-habitaciones",
    "/gestion-tipo-habitaciones",
    "/gestion-tarifa-habitaciones",
    "/servicios-extra",
    "/gastos-generales-hotel",
    "/gestion-cuentas-bancarias",
    "/extrasadmin",
  ];

  // Administrador y Reportes (rol 10)
  const rutasAdmyReportes = [
    "/crear-codigos-descuento",
    "/reporte-pagos-dia",
    "/propinas-restaurante",
    "/reportes-hotel",
    "/ingresos-hospedaje",
    "/reportes-restaurante",
    "/cuentas-pendientes-administracion",
    "/reservas-pendientes-de-pago",
    "/cierre-caja-fechas",
    "/reporte-camas",
  ];

  // Administrador y Encargado Inventarios (rol 5)
  const rutasAdmyEncargadoInv = [
    "/inventario-tienda",
    "/inventario-recepcion",
    "/inventario-lavanderia",
    "/inventario-sobrante",
    "/inventario-general-hotel",
    "/compras-inventario-general-hotel",
    "/movimiento-inventarios-hotel",
    "/salidas-inventarios-hotel",
    "/inventario-general-restaurante",
    "/compras-inventariogeneral-restaurante",
    "/movimientos-inventarios-restaurante",
    "/salidas-inventarios-restaurante",
    "/inventario-cocina",
    "/inventario-barra",
    "/inventario-mobiliario-restaurante",
    "/inventario-limpieza-restaurante",
    "/categorias-platillos",
    "/opciones-platillos",
    "/grupos-opciones",
    "/grupos-opciones-guarniciones",
    "/opciones-guarniciones",
    "/platillos-menu",
    "/platillos-restaurante",
    "/empaque-pedidos",
  ];

  // Solo Recepcionista
  const rutasSoloRecepcionista = [
    "/crear-reserva",
    "/reservas",
    "/venta-servicios-extras",
    "/clientes-en-espera",
    "/priorizar-limpieza",
  ];

  // Administrador, Recepcionista y Encargado Inventarios (rol 5)
  const rutasAdmRecepEncargadoInv = ["/venta-tienda"];

  // Administrador, Recepcionista y Mantenimiento
  const rutasAdmRecepMant = ["/habitaciones-mantenimiento"];

  // Solo Limpieza
  const rutasSoloLimpieza = ["/limpieza-habitaciones"];

  // Solo Mantenimiento
  const rutasSoloMantenimiento = [];

  // Solo Mesero (rol 7)
  const rutasSoloMesero = ["/seleccionar-mesa"];

  // Mesero, Cajero y Recepcionista de Restaurante (roles 2, 7 y 8)
  const rutasMeseroCajero = [
    "/cuentas-pendientes-mesas",
    "/cuentas-cargadas-habitacion",
    "/pagar-cuenta-pedido",
  ];

  // Historial restaurante (roles 1, 2, 5, 8, 10)
  const rutasHistorialRestaurante = [
    "/historial-pagos-restaurante",
    "/historial-comandas",
  ];

  // Solo Cajero (rol 8)
  const rutasSoloCajero = [];

  // Solo Pantallas (rol 9)
  const rutasSoloPantallas = ["/pantalla-cocina", "/pantalla-barra"];

  // Administrador Y Mantenimiento
  const rutasCompartidasAdmyMant = ["/control-mantenimiento"];

  // Administrador, Recepcionista y Limpieza
  const rutasTareasMantenimiento = ["/gestion-mantenimiento"];

  // Administrador y Recepcionista
  const rutasObservacionLimpieza = ["/observaciones-limpieza"];

  // Administrador, Recepcionista y Limpieza
  const rutasNotasSupervision = ["/notas-supervision"];

  // Administrador y Supervisor de Limpieza (Rol 6)
  const rutasAdmySupervisor = ["/supervisar-limpieza"];

  // Administrador y Recepcionista
  const rutasAdmyRecep = [
    "/caja-chica",
    "/imprimir-cierre-caja",
    "/cambiar-habitacion-reserva",
    "/imprimir-cambios-habitacion",
    "/imprimir-reporte-limpieza",
    "/liberar-habitaciones",
    "/listado-huesped",
    "/historial-pagos-hotel",
  ];

  // Administrador, Recepcionista y Reportes
  const rutasAdmRecepReportes = ["/depositos-efectivo", "/cierre-caja-diario"];

  // Solo Contador (rol 11) y Administrador (rol 1)
  const rutasContabilidad = [
    "/contabilidad/dashboard",
    "/contabilidad/ingresos-diarios",
    "/contabilidad/liquidacion-tarjetas",
    "/contabilidad/caja-chica-admin",
    "/contabilidad/no-facturado",
    "/contabilidad/facturas-anuladas",
  ];

  // Contador (11), Administrador (1) y Reportes (10) — Corte de Ventas
  const rutasCorteVentas = ["/contabilidad/corte-ventas"];

  // Administrador (1), Recepcionista (2), Cajero Restaurante (8) y Contador (11)
  const rutasPagosCredito = ["/contabilidad/pagos-credito"];

  // Verificar permisos
  if (
    rutasContabilidad.includes(to.path) &&
    user?.IdRol !== 1 &&
    user?.IdRol !== 11
  ) {
    return next("/inicio");
  }
  if (
    rutasCorteVentas.includes(to.path) &&
    user?.IdRol !== 1 &&
    user?.IdRol !== 10 &&
    user?.IdRol !== 11
  ) {
    return next("/inicio");
  }
  if (
    rutasPagosCredito.includes(to.path) &&
    user?.IdRol !== 1 &&
    user?.IdRol !== 2 &&
    user?.IdRol !== 8 &&
    user?.IdRol !== 11
  ) {
    return next("/inicio");
  }
  if (rutasSoloRecepcionista.includes(to.path) && user?.IdRol !== 2) {
    return next("/inicio");
  }
  if (
    rutasAdmRecepEncargadoInv.includes(to.path) &&
    user?.IdRol !== 1 &&
    user?.IdRol !== 2 &&
    user?.IdRol !== 5
  ) {
    return next("/inicio");
  }
  if (rutasSoloAdm.includes(to.path) && user?.IdRol !== 1) {
    return next("/inicio");
  }
  if (
    rutasAdmyReportes.includes(to.path) &&
    user?.IdRol !== 1 &&
    user?.IdRol !== 10 &&
    user?.IdRol !== 11
  ) {
    return next("/inicio");
  }
  if (rutasSoloLimpieza.includes(to.path) && user?.IdRol !== 3) {
    return next("/inicio");
  }
  if (rutasSoloMantenimiento.includes(to.path) && user?.IdRol !== 4) {
    return next("/inicio");
  }
  if (
    rutasCompartidasAdmyMant.includes(to.path) &&
    user?.IdRol !== 1 &&
    user?.IdRol !== 4
  ) {
    return next("/inicio");
  }
  if (
    rutasTareasMantenimiento.includes(to.path) &&
    user?.IdRol !== 1 &&
    user?.IdRol !== 2 &&
    user?.IdRol !== 3
  ) {
    return next("/inicio");
  }
  if (
    rutasObservacionLimpieza.includes(to.path) &&
    user?.IdRol !== 1 &&
    user?.IdRol !== 2
  ) {
    return next("/inicio");
  }
  if (
    rutasNotasSupervision.includes(to.path) &&
    user?.IdRol !== 1 &&
    user?.IdRol !== 2 &&
    user?.IdRol !== 3
  ) {
    return next("/inicio");
  }
  if (
    rutasAdmRecepReportes.includes(to.path) &&
    user?.IdRol !== 1 &&
    user?.IdRol !== 2 &&
    user?.IdRol !== 10
  ) {
    return next("/inicio");
  }
  if (
    rutasAdmyRecep.includes(to.path) &&
    user?.IdRol !== 1 &&
    user?.IdRol !== 2
  ) {
    return next("/inicio");
  }
  if (
    rutasAdmRecepMant.includes(to.path) &&
    user?.IdRol !== 1 &&
    user?.IdRol !== 2 &&
    user?.IdRol !== 4
  ) {
    return next("/inicio");
  }
  if (
    rutasAdmySupervisor.includes(to.path) &&
    user?.IdRol !== 1 &&
    user?.IdRol !== 6
  ) {
    return next("/inicio");
  }
  if (
    rutasAdmyEncargadoInv.includes(to.path) &&
    user?.IdRol !== 1 &&
    user?.IdRol !== 5
  ) {
    return next("/inicio");
  }
  if (
    rutasSoloMesero.includes(to.path) &&
    user?.IdRol !== 7 &&
    user?.IdRol !== 1
  ) {
    return next("/inicio");
  }
  if (
    rutasMeseroCajero.includes(to.path) &&
    user?.IdRol !== 1 &&
    user?.IdRol !== 2 &&
    user?.IdRol !== 7 &&
    user?.IdRol !== 8
  ) {
    return next("/inicio");
  }
  // Cajero restaurante (rol 8) no puede pagar desde mesero
  if (to.path.startsWith("/pagar-cuenta-pedido") && user?.IdRol === 8) {
    return next("/cuentas-pendientes-mesas");
  }
  if (
    rutasHistorialRestaurante.includes(to.path) &&
    user?.IdRol !== 1 &&
    user?.IdRol !== 2 &&
    user?.IdRol !== 5 &&
    user?.IdRol !== 8 &&
    user?.IdRol !== 10
  ) {
    return next("/inicio");
  }
  if (
    rutasSoloCajero.includes(to.path) &&
    user?.IdRol !== 8 &&
    user?.IdRol !== 1
  ) {
    return next("/inicio");
  }
  if (
    rutasSoloPantallas.includes(to.path) &&
    user?.IdRol !== 9 &&
    user?.IdRol !== 1
  ) {
    return next("/inicio");
  }

  next();
});

export default router;
